<template>
  <div class="loadingView" v-if="loadingForm">
    <LoadingList v-model="loadingForm" text="Carregando dados." />
  </div>
  <div v-else>
    <RequiredFieldsMessage />
    <b-card-header header-tag="header" role="tab">
      <h5 style="padding-top: 0px" v-b-toggle.accordion-1>
        Informações do Aluno
      </h5>
    </b-card-header>
    <b-collapse
      id="accordion-1"
      visible
      accordion="my-accordion"
      role="tabpanel"
    >
      <b-row>
        <b-col md="2">
          <div class="form-group required photo-field">
            <ProfilePhoto
              modalId="studentData"
              :photo="
                typeof value.photo !== 'string' ? photoStudent : value.photo
              "
              :callback="setNewPhoto"
            />
          </div>
        </b-col>
        <b-col md="10">
          <b-row>
            <b-col md="6">
              <StandardInput
                v-model="value.name"
                class="required-cme required"
                type="text"
                name="name"
                label="Nome completo"
                :error="nameStudantValidate"
                labelError="Digite nome e sobrenome"
                placeholder
                validateFullName
              />
            </b-col>
            <b-col md="3">
              <b-form-group class="required-cme required">
                <StandardInput
                  v-model="value.birth_date"
                  class="required-cme required"
                  type="text"
                  name="birth_date"
                  label="Data de nascimento"
                  v-mask="'##/##/####'"
                  placeholder
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="required-cme required">
                <label for="label">Mora com</label>
                <multiselect
                  open-direction="bottom"
                  v-model="value.lives_with"
                  :options="options.livesWith"
                  :multiple="false"
                  placeholder="Selecione"
                  selectLabel
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group class="required-cme required">
                <label for="label">Guarda do aluno</label>
                <multiselect
                  open-direction="bottom"
                  v-model="value.guardian"
                  :options="options.custodies"
                  :multiple="false"
                  placeholder="Selecione"
                  selectLabel
                />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group class="required-cme required">
                <label for="label">Etnia</label>
                <multiselect
                  open-direction="bottom"
                  v-model="value.ethnicity"
                  :options="options.ethnicities"
                  :multiple="false"
                  placeholder="Selecione"
                  selectLabel
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="required-cme required">
                <label for="label">Sexo</label>
                <multiselect
                  open-direction="bottom"
                  v-model="value.gender"
                  :options="options.genders"
                  :multiple="false"
                  placeholder="Selecione"
                  selectLabel
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="required-cme required">
                <label for="label">Cor</label>
                <multiselect
                  open-direction="bottom"
                  v-model="value.skin_color"
                  :options="options.skinColors"
                  :multiple="false"
                  placeholder="Selecione"
                  selectLabel
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-collapse>

    <!-- Block -->
    <b-card-header header-tag="header" role="tab">
      <h5 v-b-toggle.accordion-2>Irmãos</h5>
    </b-card-header>
    <b-collapse
      id="accordion-2"
      visible
      accordion="my-accordion"
      role="tabpanel"
    >
      <b-row class="mb-3">
        <b-col md="3">
          <fieldset class="form-group required">
            <legend></legend>
            <label for="hasSiblings">Possui irmão</label>
            <b-form-select
              v-model="hasSiblings"
              id="hasSiblings"
              :options="hasSiblingsOptions"
              @change="setSiblings(value.EnrollmentStudentBrothers)"
            />
          </fieldset>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <template v-if="value.EnrollmentStudentBrothers.length != 0">
          <b-col>
            <StandardInput
              v-model="value.EnrollmentStudentBrothers[0].name"
              type="text"
              name="name"
              label="Nome"
              placeholder
            />
          </b-col>
          <b-col md="2">
            <StandardInput
              v-model="value.EnrollmentStudentBrothers[0].age"
              type="number"
              name="age"
              label="Idade"
              placeholder
            />
          </b-col>
          <b-col>
            <StandardInput
              v-model="value.EnrollmentStudentBrothers[0].school"
              type="text"
              name="school"
              label="Escola"
              placeholder
            />
          </b-col>
        </template>
      </b-row>
      <div v-if="value.EnrollmentStudentBrothers.length != 0">
        <b-row
          v-for="(sibling, i) in value.EnrollmentStudentBrothers.slice(1)"
          :key="i"
          class="mb-3"
        >
          <b-col>
            <StandardInput
              v-model="value.EnrollmentStudentBrothers[i + 1].name"
              type="text"
              name="name"
              label="Nome"
              placeholder
            />
          </b-col>
          <b-col md="2">
            <StandardInput
              v-model="value.EnrollmentStudentBrothers[i + 1].age"
              type="number"
              name="age"
              label="Idade"
              placeholder
            />
          </b-col>
          <b-col>
            <StandardInput
              v-model="value.EnrollmentStudentBrothers[i + 1].school"
              type="text"
              name="school"
              label="Escola"
              placeholder
            />
          </b-col>
          <b-col md="1" class="delete-col">
            <span @click="() => removeSiblingFromList(i)" class="icon-delete">
              <DeleteIcon />
            </span>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col md="3">
          <b-button
            @click="addSibling"
            :class="{ disabled: hasSiblings == 'nao' }"
            class="btn large blue mb-5 add-brother"
            v-b-modal.change-password
          >
            <b-icon-plus-lg /> Adicionar irmão
          </b-button>
        </b-col>
      </b-row>
    </b-collapse>

    <b-card-header header-tag="header" role="tab">
      <h5 v-b-toggle.accordion-3>Matrícula</h5>
    </b-card-header>
    <b-collapse
      id="accordion-3"
      visible
      accordion="my-accordion"
      role="tabpanel"
    >
      <p class="purple info">Período e ano a frequentar.</p>

      <b-row>
        <b-col md="3">
          <b-form-group class="required">
            <label for="label">Segmento</label>
            <div>
              <multiselect
                open-direction="bottom"
                v-model="value.segment"
                :options="availableSegments"
                :multiple="false"
                placeholder="Selecione o segmento"
                :selectLabel="false"
                @input="onSegmentChange"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        class="row-enrollment"
        v-if="
          value.segment === 'Infantil' && availableGradesInfantil.length > 0
        "
      >
        <b-col>
          <b-form-group class="group-radio">
            <b-form-radio
              v-model="value.grade"
              name="matricula"
              v-for="(item, index) in availableGradesInfantil"
              :key="index"
              :value="item.grade"
              @change="handleGrade(item)"
            >
              {{
                is_reenrollment
                  ? item.reenrollment_description
                  : item.enrollment_description
              }}
              <span
                :class="
                  item.time_period === 'vespertino' ? 'gradient1' : 'gradient2'
                "
              >
                - {{ item.time_period === "vespertino" ? "Tarde" : "Manhã" }}
              </span>
            </b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        class="row-enrollment"
        v-if="value.segment === 'Pititim' && availableGradesPititim.length > 0"
      >
        <b-col>
          <b-form-group class="group-radio" v-show="false">
            <b-form-radio
              v-model="value.grade"
              name="matricula"
              v-for="(item, index) in availableGradesPititim"
              :key="index"
              value="B1_8"
            >
            </b-form-radio>
          </b-form-group>

          <div v-if="value.grade === 'B1_8'" style="max-width: 870px">
            <template v-if="rdaUnit === 'BELO_HORIZONTE'">
              <label for="label">Idade</label>
              <b-form-group class="group-radio" style="padding-bottom: 10px">
                <b-form-radio
                  v-model="value.year_id"
                  name="ano"
                  v-for="(item, index) in [
                    { text: '1 ano', value: 1 },
                    { text: '2 anos', value: 2 },
                    { text: '3 anos', value: 3 },
                  ]"
                  :key="index"
                  :value="item.value"
                  inline
                  stacked="md"
                >
                  {{ item.text }}
                </b-form-radio>
              </b-form-group>

              <label for="label">Módulos</label>
              <b-card>
                <table
                  class="table table-bordered text-center align-middle"
                  style="margin: 0"
                >
                  <thead>
                    <tr>
                      <th
                        style="width: 120px; min-width: 120px; max-width: 120px"
                      ></th>
                      <th
                        v-for="day in days"
                        :key="day.value"
                        style="
                          width: 140px;
                          min-width: 140px;
                          max-width: 140px;
                          font-size: 14px;
                          font-weight: normal;
                        "
                      >
                        {{ day.text }}
                      </th>
                    </tr>
                  </thead>
                  <tbody style="margin: 0px">
                    <tr v-for="period in periods" :key="period.value">
                      <td class="text-start fw-bold">{{ period.text }}</td>
                      <td
                        v-for="day in days"
                        :key="day.value"
                        class="text-center align-middle"
                      >
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                          "
                        >
                          <b-form-checkbox
                            :checked="isChecked(period.value, day.value)"
                            @change="() => toggleDay(period.value, day.value)"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-card>
            </template>
            <template v-if="rdaUnit === 'POUSO_ALEGRE'">
              <b-form-group class="group-radio" style="padding-bottom: 10px">
                <b-form-radio
                  v-model="value.year_id"
                  name="ano"
                  v-for="(item, index) in [{ text: 'Manhã', value: 1 }]"
                  :key="index"
                  :value="item.value"
                  stacked="md"
                >
                  {{ item.text }}
                </b-form-radio>
              </b-form-group>
            </template>
          </div>
        </b-col>
      </b-row>

      <b-row
        class="row-enrollment"
        v-if="
          value.segment === 'Ensino fundamental' &&
          availableGradesFundamental.length > 0
        "
      >
        <b-col>
          <b-form-group class="group-radio" label="Ensino fundamental">
            <b-form-radio
              v-for="(item, index) in availableGradesFundamental"
              :key="index"
              v-model="value.grade"
              name="matricula"
              :value="item.grade"
              @change="setPeriod(item)"
            >
              {{
                is_reenrollment
                  ? item.reenrollment_description
                  : item.enrollment_description
              }}
              <span
                :class="
                  item.time_period === 'vespertino' ? 'gradient1' : 'gradient2'
                "
              >
                - {{ item.time_period === "vespertino" ? "Tarde" : "Manhã" }}
              </span>
            </b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-if="
          value.segment === 'Ensino médio' &&
          availableGradesEnsinoMedio.length > 0
        "
        class="row-enrollment"
      >
        <b-col>
          <b-form-group class="group-radio">
            <b-form-radio
              v-for="(item, index) in availableGradesEnsinoMedio"
              :key="index"
              v-model="value.grade"
              name="matricula"
              :value="item.grade"
              @change="setPeriod(item)"
            >
              {{
                is_reenrollment
                  ? item.reenrollment_description
                  : item.enrollment_description
              }}
              <span
                :class="
                  item.time_period === 'vespertino' ? 'gradient1' : 'gradient2'
                "
              >
                - {{ item.time_period === "vespertino" ? "Tarde" : "Manhã" }}
              </span>
            </b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>

      <div
        class="status-box"
        v-if="
          value.segment === 'Ensino fundamental' ||
          value.segment === 'Ensino médio'
        "
      >
        <p class="info" v-if="rdaUnit != 'POUSO_ALEGRE'">
          Obs: A partir do 8° ano os alunos da manhã também têm aulas no período
          da tarde. Para mais informações, contate a Escola.
        </p>
      </div>

      <b-row
        :style="
          value.segment === 'Ensino fundamental' ||
          value.segment === 'Ensino médio'
            ? ''
            : 'padding-top:20px;'
        "
      >
        <b-col md="4">
          <StandardInput
            v-model="value.previous_school"
            type="text"
            name="escola"
            label="Escola anterior (Deixar em branco caso não possua)"
            placeholder
            :required="false"
          />
        </b-col>
      </b-row>
    </b-collapse>

    <b-card-header header-tag="header" role="tab">
      <h5 v-b-toggle.accordion-4>Dados de endereço</h5>
    </b-card-header>
    <b-collapse
      id="accordion-4"
      visible
      accordion="my-accordion"
      role="tabpanel"
    >
      <div v-if="!loadingCep">
        <b-row>
          <b-col>
            <StandardInput
              v-model="value.Address.cep"
              class="required required-cme"
              type="text"
              name="cep"
              label="CEP"
              v-mask="'#####-###'"
              placeholder
              @onchange="getAddress(value.Address.cep)"
            />
          </b-col>
          <b-col>
            <b-form-group class="required required-cme">
              <label for="label">Estado</label>
              <multiselect
                open-direction="bottom"
                v-model="value.Address.state"
                :options="options.uf"
                :multiple="false"
                placeholder="Selecione um estado"
                selectLabel
              />
            </b-form-group>
          </b-col>
          <b-col>
            <StandardInput
              v-model="value.Address.city"
              class="required required-cme"
              type="text"
              name="city"
              label="Cidade"
              placeholder
            />
          </b-col>
          <b-col>
            <StandardInput
              v-model="value.Address.neighborhood"
              class="required required-cme"
              type="text"
              name="neighborhood"
              label="Bairro"
              placeholder
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <StandardInput
              v-model="value.Address.street"
              class="required required-cme"
              type="text"
              name="address"
              label="Endereço"
              placeholder
            />
          </b-col>
          <b-col>
            <StandardInput
              v-model="value.Address.number"
              class="required required-cme"
              type="text"
              name="number"
              label="Número"
              placeholder
            />
          </b-col>
          <b-col>
            <StandardInput
              v-model="value.Address.complement"
              type="text"
              name="complement"
              label="Complemento"
              placeholder
              :required="false"
            />
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row align="center">
          <b-col class="mt-5">
            <b-spinner
              variant="success"
              label="Pesquisando o CEP..."
            ></b-spinner>
          </b-col>
        </b-row>
      </div>
    </b-collapse>

    <b-card-header header-tag="header" role="tab">
      <h5 v-b-toggle.accordion-5>Contatos</h5>
    </b-card-header>
    <b-collapse
      id="accordion-5"
      visible
      accordion="my-accordion"
      role="tabpanel"
    >
      <b-row>
        <b-col>
          <StandardInput
            v-model="value.phone1"
            class="required-cme required"
            type="text"
            name="phone-1"
            label="Telefone 1"
            v-mask="'(##) #####-####'"
            placeholder
          />
        </b-col>
        <b-col>
          <StandardInput
            v-model="value.phone2"
            type="text"
            name="phone-2"
            label="Telefone 2"
            v-mask="'(##) #####-####'"
            placeholder
            :required="false"
          />
        </b-col>
        <b-col>
          <StandardInput
            v-model="value.email"
            class="required-cme required mb-4"
            type="email"
            name="email"
            label="E-mail do Aluno"
            placeholder
            :disabled="studentHasNoEmail ? true : false"
          />

          <b-form-checkbox @change="changeEmail()"
            >Aluno menor de 10 anos e não possui e-mail.</b-form-checkbox
          >
        </b-col>
      </b-row>
    </b-collapse>

    <b-card-header header-tag="header" role="tab">
      <h5 v-b-toggle.accordion-6>Documentos</h5>
    </b-card-header>
    <b-collapse
      id="accordion-6"
      visible
      accordion="my-accordion"
      role="tabpanel"
    >
      <b-row>
        <b-col md="12">
          <p class="purple info">Preencha ao menos um dos campos abaixo</p>
        </b-col>
        <b-col md="4">
          <fieldset class="form-group" :class="{ 'required-cme': documentsMissing, 'required': documentsMissing }">
            <legend></legend>
            <label for="hasSiblings">CPF</label>
            <b-form-input
              v-model="value.cpf"
              :state="value.cpf ? verificarCpf : null"
              type="text"
              name="cpf"
              label="CPF"
              v-mask="'###.###.###-##'"
              placeholder
            ></b-form-input>
          </fieldset>
        </b-col>
        <b-col md="4">
          <StandardInput
            v-model="value.birth_certificate"
            :class="{ required: documentsMissing }"
            type="text"
            name="birth-certificate"
            label="Certidão de nascimento"
            placeholder
            :required="false"
            :error="documentsMissing"
          />
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import * as lang from "vuejs-datepicker/src/locale";
import utils from "@/utils";
import ProfilePhoto from "@/components/ProfilePhoto.vue";
import StandardInput from "@/components/inputs/StandardInput.vue";
import DeleteIcon from "@/components/svg/DeleteIcon.vue";
import getAddressByCep from "@/services/getAddressByCep";
import httpRda from "../../../http-rda";
import getStateNameByAcronym from "../../../utils/getStateNameByAcronym";
import LoadingList from "@/components/LoadingList.vue";
import RequiredFieldsMessage from "@/components/RequiredFieldsMessage.vue";

export default {
  name: "StudentData",
  components: {
    ProfilePhoto,
    StandardInput,
    DeleteIcon,
    LoadingList,
    RequiredFieldsMessage,
  },

  props: ["value", "nameStudantValidate", "cycles", "isReEnroll"],

  data() {
    return {
      days: [
        { text: "Segunda-Feira", value: "segunda" },
        { text: "Terça-Feira", value: "terca" },
        { text: "Quarta-Feira", value: "quarta" },
        { text: "Quinta-Feira", value: "quinta" },
        { text: "Sexta-Feira", value: "sexta" },
      ],
      periods: [
        { text: "Manhã", value: "manha" },
        { text: "Tarde", value: "tarde" },
      ],
      periodDictionary: {
        matutino: "Matutino",
        vespertino: "Vespertino",
      },
      loadingForm: true,
      loadingCep: false,
      hasSiblings: null,
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      is_reenrollment: this.$route.name.includes("rematricula") ? true : false,
      enrollment_id: this.$route.params.id,
      segment: null,
      photoStudent: null,
      language: "ptBR",
      languages: lang,
      rawDate: "",
      studentHasNoEmail: false,
      disabledDates: {
        from: new Date(),
      },
      hasSiblingsOptions: [
        { value: "nao", text: "Não" },
        { value: "sim", text: "Sim" },
      ],
    };
  },

  computed: {
    propModel: {
      get() {
        return this.prop;
      },
      set(value) {
        this.$emit("update:prop", value);
      },
    },

    options() {
      return utils.options;
    },

    verificarCpf() {
      if (this.value.cpf != undefined) {
        const validarCPF = utils.validateCPF(this.value.cpf);
        return validarCPF ? true : false;
      } else {
        return false;
      }
    },

    documentsMissing() {
      return !this.value.cpf && !this.value.birth_certificate;
    },

    arrCycles() {
      return this.cycles && Object.keys(this.cycles).length ? this.cycles : null;
    },

    availableSegments() {
      if (!this.arrCycles) {
        return [];
      }
      const segments = [];

      if (this.arrCycles.pititim && this.arrCycles.pititim.length > 0) {
        segments.push("Pititim");
      }

      if (this.arrCycles.infantil && this.arrCycles.infantil.length > 0) {
        segments.push("Infantil");
      }
      if (this.arrCycles.fundamental && this.arrCycles.fundamental.length > 0) {
        segments.push("Ensino fundamental");
      }
      if (this.arrCycles.ensinoMedio && this.arrCycles.ensinoMedio.length > 0) {
        segments.push("Ensino médio");
      }
      return segments;
    },

    availableGradesPititim() {
      if (!this.arrCycles) return [];
      return this.arrCycles.pititim || [];
    },

    availableGradesInfantil() {
      if (!this.arrCycles) return [];
      return this.arrCycles.infantil || [];
    },

    availableGradesFundamental() {
      if (!this.arrCycles) {
        return [];
      }
      return this.arrCycles.fundamental || [];
    },

    availableGradesEnsinoMedio() {
      if (!this.arrCycles) {
        return [];
      }
      return this.arrCycles.ensinoMedio || [];
    },
  },
  methods: {
    setPeriod(item) {
      if (this.value.segment === "Pititim") {
        this.value.time_period = null;
        return;
      }
      this.value.time_period = this.periodDictionary[item.time_period];
    },
    handleGrade(grade) {
      this.setPeriod(grade);
      this.value.pititim_grade_days = {
        manha: [],
        tarde: [],
      };
    },

    isChecked(period, day) {
      if (!this.value.pititim_grade_days) {
        return false;
      }
      const list = this.value.pititim_grade_days[period] || [];
      return list.includes(day);
    },

    toggleDay(period, day) {
      if (!Array.isArray(this.value.pititim_grade_days[period])) {
        this.value.pititim_grade_days[period] = [];
      }
      const daysArr = this.value.pititim_grade_days[period];
      const idx = daysArr.indexOf(day);
      if (idx === -1) {
        daysArr.push(day);
      } else {
        daysArr.splice(idx, 1);
      }

      this.$set(this.value, "pititim_grade_days", {
        ...this.value.pititim_grade_days,
      });
    },

    toggleAllDaysOfPeriod(period) {
      if (!Array.isArray(this.value.pititim_grade_days[period])) {
        this.value.pititim_grade_days[period] = [];
      }

      this.value.pititim_grade_days[period] = this.days.map((d) => d.value);
    },

    resetGrade() {
      this.value.grade = null;
      this.value.segment = null;
    },

    onSegmentChange() {
      if (this.value.segment === "Pititim") {
        this.value.grade = "B1_8";
        this.value.year_id = null;
        if (this.rdaUnit === "POUSO_ALEGRE") {
          this.toggleAllDaysOfPeriod("manha");
          this.value.year_id = 1;
        }
      } else {
        this.value.pititim_grade_days = {
          manha: [],
          tarde: [],
        };
        this.value.grade = null;
        this.value.year_id = null;
      }

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    addSibling() {
      this.value.EnrollmentStudentBrothers.push({
        name: "",
        age: "",
        school: "",
      });
    },

    async removeSiblingFromList(index) {
      try {
        await httpRda.delete(
          `/enrollments/${this.value.enrollment_id}/student/brothers/${
            this.value.EnrollmentStudentBrothers[index + 1].id
          }`
        );
      } catch (error) {
        return;
      }
      const newList = [...this.value.EnrollmentStudentBrothers];
      newList.splice(index + 1, 1);
      this.value.EnrollmentStudentBrothers = newList;
    },

    setSiblings() {
      if (this.hasSiblings == "nao") {
        this.value.EnrollmentStudentBrothers = [];
      } else {
        this.value.EnrollmentStudentBrothers = [
          { name: "", age: "", school: "" },
        ];
      }
    },

    loadSiblings() {
      if (
        this.value.EnrollmentStudentBrothers != undefined &&
        this.value.EnrollmentStudentBrothers.length
      ) {
        this.value.hasSiblings = true;
      } else {
        this.value.hasSiblings = false;
        this.value.EnrollmentStudentBrothers = [];
      }

      this.loadingForm = false;
    },

    setNewPhoto(photo) {
      const bodyFormData = new FormData();
      bodyFormData.append("file", photo);
      this.value.photo = bodyFormData;
      this.value.shouldUpdatePhoto = false;

      this.photoStudent = photo;
    },

    getPeriod(period) {
      this.resetGrade();
      this.value.time_period = period;
      this.segment = null;
    },

    changeEmail() {
      this.studentHasNoEmail = !this.studentHasNoEmail;

      if (this.studentHasNoEmail) {
        const name =
          this.value.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "_")
            .toLowerCase() + "@escoladaserra.com.br";

        this.value.email = name;
      } else {
        this.value.email = "";
      }
    },

    async getAddress(cep) {
      this.loadingCep = true;
      await getAddressByCep(cep)
        .then((resp) => {
          this.value.Address.state = getStateNameByAcronym(resp.uf);
          this.value.Address.city = resp.localidade;
          this.value.Address.neighborhood = resp.bairro;
          this.value.Address.street = resp.logradouro;
          this.loadingCep = false;
        })
        .catch((err) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: err.message,
          });
        });
      this.loadingCep = false;
    },

  },

  watch: {
    hasSiblings() {},
    "value.previous_school"() {
      this.$nextTick(() => {
        if (this.arrCycles && this.value.segment) {
          this.$forceUpdate();
        }
      });
    },
  },

  mounted() {
    this.value.shouldUpdatePhoto = true;

    if (this.isReEnroll) {
      this.value.photo = null;
      this.photoStudent = null;
    }

    this.loadSiblings();

    this.hasSiblings =
      this.value.EnrollmentStudentBrothers.length > 0 ? "sim" : "nao";
  },
};
</script>

<style lang="scss" scoped>
.info {
  margin-left: 5px !important;
}

.card {
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  min-width: 0 !important;
  word-wrap: break-word !important;
  background-clip: border-box !important;
  border-radius: 0.25rem !important;
}

.card-body {
  padding: 0 !important;
}

.row-enrollment {
  padding-bottom: 0 !important;
}
</style>
